import React from 'react'

const ArrowDownSortIcon = props => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width={props.width ? props.width : 24} height={props.height ? props.height : 24} viewBox="0 0 24 24" fill="none" stroke="currentColor"
         strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
        >
        <path d="m3 16 4 4 4-4"/>
        <path d="M7 20V4"/>
        <path d="M11 4h10"/>
        <path d="M11 8h7"/>
        <path d="M11 12h4"/>
    </svg>
)

export default ArrowDownSortIcon;


// WEBPACK FOOTER //
// ./src/assets/icons/ArrowDownSortIcon.jsx